import { I10DIAMPUISS_State } from '@batical/types/src'

const I10DIAMPUISS: I10DIAMPUISS_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  material_uuid: 'Inox',
  in_puissance: 562.32,
  in_delatTemp: 12.58,
  viscosite_uuid: 'EEEECF26-EA40-4D13-AD09-0D99596F9F9C',
  in_vitesse: 1.2,
  perteCharg_uuid: '6D91E213-CFEA-4A37-A3FF-5A3D10E60966',
  res_debitReel: 0.0,
  tube_uuid: '',
  res_perteChargeResultat: 0.0,
  res_vMax: 0.0,
  mode: 'none',
  calcul_code: 'I10DIAMPUISS',
  dataChart: [],
  dataLine: [],
  dataBar: [],
  preivousMat: ''
}

export default I10DIAMPUISS
